<template>
    <v-layout>
        <PointsHistory />
    </v-layout>
</template>

<script>
import PointsHistory   from '@/components/view_blocks/Points_history/Points_history_wrap.vue';
import {mapGetters} from 'vuex';

export default {
  components: {
    PointsHistory,
  },
  computed: {

  },
};
</script>
